import { config } from '@/config';

import type { SignupStatus } from './signupApi';

const STARTER_LAYER = 'total-suitability';

/** A signup response carries the starter project only when it also set a session. */
export function hasSession(status: SignupStatus): boolean {
  return status.collection_id !== undefined;
}

/**
 * Reload to bootstrap the new session on its starter project. Replaces the signup page in history,
 * so the browser's back button can't return to its code form.
 */
export function enterPlatform(status: SignupStatus): void {
  const base = config.app.basename.endsWith('/') ? config.app.basename : `${config.app.basename}/`;
  const params = new URLSearchParams({ layer: STARTER_LAYER });
  if (status.collection_id) params.set('projectId', String(status.collection_id));

  window.location.replace(`${base}map?${params.toString()}`);
}

/** Whether a router path (basename already removed) is one of the signup pages. */
export function isSignupPath(pathname: string): boolean {
  return pathname === '/signup' || pathname.startsWith('/signup/');
}
